export default defineAppConfig({
    ui: {
        primary: 'blue',
        gray: 'slate',
        orange: 'orange',
        button: {
            rounded: 'rounded',
            variant: {
                solid: "shadow-sm text-white dark:text-gray-900 bg-{color}-700 hover:bg-{color}-800 disabled:bg-{color}-500 dark:bg-{color}-400 dark:hover:bg-{color}-500 dark:disabled:bg-{color}-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-{color}-500 dark:focus-visible:outline-{color}-400",
                ghost: "text-{color}-700 dark:text-{color}-400 hover:bg-{color}-50 disabled:bg-transparent dark:hover:bg-{color}-950 dark:disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-{color}-500 dark:focus-visible:ring-{color}-400",
                normal: "text-{color}-700 dark:text-{color}-400 bg-{color}-100 hover:bg-{color}-200 disabled:bg-{color}-100 dark:bg-{color}-950 dark:hover:bg-{color}-900 dark:disabled:bg-{color}-950 focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-{color}-600 dark:focus-visible:ring-{color}-400",
                outline: 'text-{color}-700'
            },
        },
        buttonGroup: {
            rounded: 'rounded'
        },
        modal: {
            rounded: 'rounded-md',
            base: 'relative text-left rtl:text-right overflow-hidden flex flex-col overflow-auto'
        },
        card: {
            rounded: 'rounded-md',
            body: {
                padding: 'sm:px-4 sm:py-3',
            },
            header: {
                padding: 'sm:px-4 sm:pb-2 sm:pt-3'
            },
            footer: {
                padding: 'sm:px-4 sm:py-2'
            },
        },
        tabs: {
            rounded: 'rounded-md',
            list: { height: 'h-9', tab: { height: 'h-7' } }
        },
        pagination: {
            // default: {
            //     activeButton: {
            //         color: 'blue',
            //     }
            // }
        },
        notification: {
            position: 'top-0 bottom-auto'
        }
    }
})